import { validateSomething } from "../../Form/Validations";
import { toast } from "react-toastify";
import RestAPI from "@aws-amplify/api-rest";

export class ZentraCloud {
    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n) {
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const body = {
                    tipo: "ZENTRACLOUD",
                    deviceSn: props.dialogState.data.deviceSn,
                    apiToken: props.dialogState.data.apiToken,
                    sectorName: values.sector,
                    nodeName: "ZentraCloud - " + values.station,
                    locale: i18n.language
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: t("external.serial-number"),
                            campo: "deviceSn",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            label: t("external.api-token"),
                            campo: "apiToken",
                            validation: validateSomething,
                            component: "text",
                        },
                    ],
                },
                {
                    label: t("external.conectar"),
                    inputs: [
                        {
                            label: t("external.serial-number"),
                            campo: "deviceSn",
                            component: "text",
                            edit: false
                        },
                        {
                            label: t("external.zentracloud-station-name"),
                            campo: "station",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            label: t("external.sector-name"),
                            campo: "sector",
                            validation: validateSomething,
                            component: "text",
                        },
                    ],
                },
            ],
        };
    }

    static async validateLogin(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const erUser = validateSomething(values.deviceSn);
                if (erUser !== undefined) errors.deviceSn = erUser;

                const erPass = validateSomething(values.apiToken);
                if (erPass !== undefined) errors.apiToken = erPass;

                if(errors.deviceSn || errors.apiToken) return errors;

                if (isSubmitting){
                    props.setForceLoading(true);
                    const param = `/external/${props.farmId}`;
                    const body = { validate: true, apiToken: values.apiToken, deviceSn: values.deviceSn };
                    await RestAPI.post("apiAdminDropControl", param, { body });

                    // set data that it will be used in the next step of the form
                    props.setDialogState(s => ({
                        ...s,
                        data: {
                            deviceSn: values.deviceSn,
                            apiToken: values.apiToken,
                            station: props.t("external.zentracloud-station"),
                            sector: props.t("external.zentracloud-zone")
                        }
                    }));
                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            if (error.response.status === 429) {
                const secondsRegex = /expires in (\d+) seconds/;
                const secondsMatch = error?.response?.data?.detail?.match(secondsRegex);
                if (secondsMatch && secondsMatch.length > 1) {
                    const seconds = parseInt(secondsMatch[1], 10);
                    toast.warn(props.t("forms.toastError429mktp", { seconds }), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                    errors.unknown = props.t("forms.toastError429mktp", { seconds });
                    props.setForceLoading(false);
                    return errors;
                } else {
                    toast.error(props.t("external.error-sign-in"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                    errors.unknown = props.t("external.error-sign-in");
                    props.setForceLoading(false);
                    return errors;
                }
            }
            else if (error.response?.status === 401){
                toast.error(props.t("external.incorrectZentraKeys"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("external.incorrectZentraKeys");
                props.setForceLoading(false);
                return errors;
            }
            else{
                toast.error(props.t("external.error-sign-in"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("external.error-sign-in");
                props.setForceLoading(false);
                return errors;
            }
        }
    }
}
